import { render } from "./CatalogItem.vue?vue&type=template&id=746b0075&ts=true"
import script from "./CatalogItem.vue?vue&type=script&lang=ts"
export * from "./CatalogItem.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/damianowaga/Projects/mytechaccessories/wp-content/themes/mytechaccessories/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__